export default __webpack_public_path__ + "static/media/iconCenterGPSWhite.9bd7bd3c.svg";